import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { LandingPage } from '@leagueplatform/solutions-foundation';
import { useIntl } from '@leagueplatform/locales';
import BackgroundImage from 'assets/pre-login-background.png';
import LogoImage from 'assets/HealthCoLogo.svg';
import { useNavigate } from 'react-router-dom';
import { SignInFooter } from './sign-in-footer.component';

export const PreLoginLandingPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  return (
    <LandingPage
      logo={{
        src: LogoImage,
        alt: formatMessage({ id: 'STR_APP_NAME' }),
      }}
      backgroundImage={{ src: BackgroundImage }}
      primaryButton={{
        buttonText: formatMessage({ id: 'STR_LOG_IN' }),
        onClick: () => navigate(APP_MANAGED_ROUTES.SIGN_IN),
        css: {
          width: '327px',
        },
      }}
      onAuthenticated={(appState) =>
        navigate(appState?.redirectPath || APP_MANAGED_ROUTES.HOME)
      }
      // eslint-disable-next-line no-console
      onAuthError={(error) => console.log(error)}
      signInFooter={<SignInFooter />}
      shouldDisplayErrorCaption
      ellipsis
    />
  );
};
